<template>
  <b-tooltip type="is-dark" multilined>
    <div>
      <b-progress
        class="timerProgress"
        size="is-small"
        :max="maxValue"
        style="height: 0.5rem !important"
      >
        <template #bar>
          <b-progress-bar :value="bar1Value" type="is-info"></b-progress-bar>
          <b-progress-bar :value="bar2Value" type="is-success"></b-progress-bar>
          <b-progress-bar :value="elapsedValue"></b-progress-bar>
        </template>
      </b-progress>
    </div>

    <template v-slot:content>
      <p>
        time: <b class="has-text-info">{{ bar1Value | asMmSs }}</b> /
        {{ duration / 60 }}m <i v-if="increment">(+{{ increment }}s)</i>
      </p>
      <p v-if="bufferDuration">
        buffer: <b class="has-text-success">{{ bar2Value | asMmSs }}</b> /
        {{ bufferDuration }}s
      </p>
    </template>
  </b-tooltip>
</template>

<script>
export default {
  name: "TimerProgressBar",
  props: ["duration", "bufferDuration", "timeLeft", "bufferLeft", "increment"],
  computed: {
    bar1Value() {
      return Math.max(0, this.timeLeft || 0);
    },

    bar2Value() {
      return Math.max(0, this.bufferLeft || 0);
    },

    maxValue() {
      return this.duration + (this.increment || 0) + (this.bufferDuration || 0);
    },

    elapsedValue() {
      return this.maxValue - this.bar1Value - this.bar2Value;
    },
  },
};
</script>

<style scoped>
.timerProgress {
  height: 0.5rem;
}
</style>
